export default {
  __html: `<g fill="none" fill-rule="evenodd" stroke="#5B5983" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                <path d="M1 1l5.657 5.657M1 6.657L6.657 1"/>
            </g>`
}
